import { render, staticRenderFns } from "./WorkspaceSites.vue?vue&type=template&id=21eadd50&"
import script from "./WorkspaceSites.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports